import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import ChairLiftUsers from "../ChairLift/ChairLiftusers";

const ParkingUsers = () => {
 

  return (
    <div className="col-12">
           <ChairLiftUsers serviceId={7} Service="Parking" />
    </div>
  );
};
export default ParkingUsers